import axios from "axios";
import axiosRetry from "axios-retry";
import { appConfig } from "../../../config";

const BASE_URL = appConfig.streamingHost || "http://localhost:9001";

// Initialize Axios Client
const axiosClient = axios.create({ baseURL: BASE_URL });

// Request Interceptors
axiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("jwtToken") || "";
  config.headers.authorization = `Bearer ${token}`;
  return config;
});

// Response Interceptors
axiosClient.interceptors.response.use((response) => {
  if (response.status === 401) {
    window.localStorage.clear();
    window.location.replace("/");
  }
  return response;
});

// Configure Axios Retry
axiosRetry(axiosClient, { retries: 3 });

export default axiosClient;
